(function () {

  const nvznAppData = JSON.parse(document.getElementById('nvzn-app-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvznAppData not found');
  log('nvznAppData:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const action = button.dataset.action;
        let arImage, dimensions;
        if (nvznAppData.product.variants && nvznAppData.product.variants.length > 0) {
          const selectedVariant = getSelectedVariant();
          if (!selectedVariant) return console.error('[NVZN] Unable to determine selected variant');
          arImage = selectedVariant.arImage || null;
          dimensions = extractDimensions(selectedVariant.option1);
          if (!dimensions.width || !dimensions.length) {
            dimensions = extractDimensions(selectedVariant.option2);
          }
        } else {
          arImage = nvznAppData.product.arImage || null;
          dimensions = extractDimensions(nvznAppData.product.title);
        }
        log('Button Action:', action);
        log('AR Image:', arImage);
        log('Dimensions:', dimensions);
        if (action === 'viewer') {
          handleFloorPreview(dimensions, arImage);
        } else if (action === 'sizer') {
          handleFloorSizer(dimensions);
        }
      });
    });
    // move container
    const sourceElement = document.querySelector('.nvzn3d-arbutton-container')?.parentElement;
    const targetElement = document.querySelector('.product-form-grid');
    if (sourceElement && targetElement) {
      targetElement.insertAdjacentElement('afterend', sourceElement);
    }
    updateButtonVisibility();
  }

  function handleFloorPreview(dimensions, arImage) {
    Nvzn3D.displayFloorPreview({
      clientId: nvznAppData.app.nvznFloorClientID,
      imageUrl: arImage,
      width: dimensions.width,
      length: dimensions.length,
      units: dimensions.units,
    });
  }

  function handleFloorSizer(dimensions) {
    Nvzn3D.displayFloorPreview({
      clientId: nvznAppData.app.nvznFloorClientID,
      width: dimensions.width,
      length: dimensions.length,
      units: dimensions.units,
      shape: dimensions.shape,
    });
  }

  function getSelectedVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || nvznAppData.product.selectedOrFirstAvailableVariantID.toString();
    if (!variantId) return console.error('[NVZN] Unable to determine variant ID');
    const variant = nvznAppData.product.variants.find((v) => v.id.toString() === variantId);
    if (!variant) return console.error(`[NVZN] Variant with ID ${variantId} not found`);
    return variant || null;
  }

  document.addEventListener('change', function (event) { 
    if (event.target.matches('select[data-product-option]')) {
      updateButtonVisibility();
    }
  });

  function updateButtonVisibility() {
    const arViewerBtnContainer = document.querySelector('.nvzn3d-arbutton-container--viewer');
    const arSizerBtnContainer = document.querySelector('.nvzn3d-arbutton-container--sizer');
    // hide both
    arViewerBtnContainer.classList.remove('show');
    arSizerBtnContainer.classList.remove('show');
    // if design mode, show viewer button
    if (nvznAppData.design_mode) {
      arViewerBtnContainer.classList.add('show');
      return;
    }
    // if does not have variants
    if (nvznAppData.product.variants.length == 0) {
      // if product has an ar image
      if (nvznAppData.product.arImage) {
        arViewerBtnContainer.classList.add('show');
      } else {
        arSizerBtnContainer.classList.add('show');
      }
      return;
    }
    // if does have variants
    if (nvznAppData.product.variants.length >= 1) {
      const selectedVariant = getSelectedVariant();
      if (selectedVariant.arImage) {
        arViewerBtnContainer.classList.add('show');
      } else {
        arSizerBtnContainer.classList.add('show');
      }
      return;
    }
  }

  function extractDimensions(sizeString) {
    // Remove parenthetical and trailing name
    let str = sizeString.split('(')[0].trim();
    // Lowercase for shape detection
    const lower = str.toLowerCase();
    let shape = 'rectangle';
    if (lower.includes('square') || lower.includes('sq.')) shape = 'square';
    if (lower.includes('round')) shape = 'round';
    // Regex to match feet/inches: 10'1", 10', 10, 10x12, 10' x 12', 10'1"x13'11", etc.
    // Match up to two numbers (with optional feet/inches marks)
    const regex = /([0-9]+(?:'[0-9]+"?)?|[0-9]+(?:'|")?)(?:\s*[x×]\s*([0-9]+(?:'[0-9]+"?)?|[0-9]+(?:'|")?))?/i;
    const match = str.match(regex);
    let width = null, length = null;
    function parseFeetInches(val) {
      if (!val) return { feet: null, inches: null };
      let feet = 0, inches = 0;
      const feetMatch = val.match(/([0-9]+)'/);
      if (feetMatch) feet = parseInt(feetMatch[1], 10);
      const inchMatch = val.match(/([0-9]+)\"/);
      if (inchMatch) inches = parseInt(inchMatch[1], 10);
      if (feetMatch && !inchMatch) {
        const inchesAfterFeetMatch = val.match(/'\s*([0-9]+)/);
        if (inchesAfterFeetMatch) inches = parseInt(inchesAfterFeetMatch[1], 10);
      }
      // If no explicit feet/inches, try as float
      if (!feetMatch && !inchMatch) {
        const asFloat = parseFloat(val.replace(/[^0-9.]/g, ''));
        if (!isNaN(asFloat)) feet = Math.floor(asFloat);
        const remainder = asFloat - feet;
        if (remainder > 0) inches = Math.round(remainder * 12);
      }
      return { feet, inches };
    }
    function formatFeetInches(obj) {
      if (!obj || obj.feet == null) return null;
      if (obj.inches && obj.inches > 0) {
        return `${obj.feet}'${obj.inches}\"`;
      } else {
        return `${obj.feet}'`;
      }
    }
    let widthObj = null, lengthObj = null;
    const splitParts = str.split(/[x×]/i).map((part) => part.trim()).filter(Boolean);
    if (splitParts.length >= 2) {
      widthObj = parseFeetInches(splitParts[0]);
      lengthObj = parseFeetInches(splitParts[1]);
    } else if (match) {
      widthObj = parseFeetInches(match[1]);
      if (match[2]) {
        lengthObj = parseFeetInches(match[2]);
      } else {
        lengthObj = widthObj;
      }
    }
    // If shape is square or round, force width = length
    if ((shape === 'square' || shape === 'round') && widthObj) {
      lengthObj = widthObj;
    }
    return {
      width: formatFeetInches(widthObj),
      length: formatFeetInches(lengthObj),
      units: 'ftin',
      shape
    };
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();